import { useEffect, useState } from 'react';
export const useFramePortalContainer = rootNode => {
  const [container, setContainer] = useState(null);
  useEffect(() => {
    const div = rootNode || document.createElement('div');
    document.body.appendChild(div);
    setContainer(div);
    return () => {
      if (document.body.contains(div)) {
        document.body.removeChild(div);
      }
    };
  }, [rootNode]);
  return {
    current: container
  };
};